import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IActionResult } from '~src/httpClient/serverApi/types/IActionResult';


export interface IUpdateConnectionsParams {
  ids: string[];       // Data source ids
  server?: string;
  port?: string;
  username?: string;
  embedPassword?: boolean;
  password?: string;
  encryptedPassword?: string;
  encryptedPasswordKeyId?: string;
  usingRemoteQueryAgent?: boolean;
  // W-22483245: Workload Identity Federation auth-mode switch.
  workgroupAuthMode?: string;
  authFederationServiceAccount?: string;
}

export class UpdateConnectionsRequest extends Request<IUpdateConnectionsParams, IActionResult> {
  constructor(params: IUpdateConnectionsParams) {
    super('updateConnections', params);
  }
}
